import {
  FAILED_GET_PRODUCT,
  FAILED_PERSIST_PRODUCT,
  RECEIVE_GET_PRODUCT,
  RECEIVE_GET_PRODUCTS,
  RECEIVE_PERSIST_PRODUCT,
  REQUEST_PERSIST_PRODUCT,
} from 'common/redux/actions/product'
import { RESET_STATE } from 'common/redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_PRODUCT:
    case FAILED_PERSIST_PRODUCT:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        },
      }
    case RECEIVE_PERSIST_PRODUCT:
    case RECEIVE_GET_PRODUCT:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_PRODUCTS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        },
      }
    case REQUEST_PERSIST_PRODUCT:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true,
        },
      }

    case RESET_STATE:
      if (action.state === 'product') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }

      return state
    default:
      return state
  }
}
